<template>
  <div
    :class="classList"
    :data-highlight-txt="$t('settlements.yourPlan')">
    <div class="package-card-header">
      <h3 class="heading-small">{{ packageOption.name }}</h3>
    </div>

    <div class="package-card-body">
      <strong class="price">
        {{ currentPackagePriceForPeriod.net_price_per_month || 0 }}
      </strong>
      <strong class="price-detail">
        {{ $t('settlements.plnPerMonth')}}
      </strong>

      <span class="price-gross">{{ $t('settlements.grossPrice')}}: {{ currentPackagePriceForPeriod.gross_price_per_month || 0 }} {{ $t('settlements.plnPerMonth')}}</span>

      <f-button
        v-if="isMinimal && showAllCallback"
        class="full-width my-1"
        theme="text"
        @click.prevent="showAllCallback">
        {{ $t('settlements.changeYourPackage')}}
      </f-button>

      <ul
        v-if="!isMinimal"
        class="package-offer-list">
        <li
          v-for="(item, itemIndex) in packageSettingsOptions"
          :key="'offer-item-' + itemIndex"
          :class="{ 'is-excluded': !packageOption[item.value] }">
            {{ item.label }}
        </li>
      </ul>
    </div>

    <div class="package-card-footer mt-auto">
      <f-button
        class="ml-0 full-width mt-1"
        :disabled="isPurchaseDisabled || !!(isCurrent && packageOption.auto_renew)"
        :theme="isCurrent ? 'dark' : 'primary-outline'"
        @click.prevent="subscribeCallback(packageOption)">
        <template v-if="isCurrent">
          <template v-if="packageOption.auto_renew">
            {{ $t('settlements.subscriptionWalidIndefinitely') }}
          </template>
          <template v-else>
            {{ $t('settlements.extendYourPackageBy', { timeTxt: $tc('time.timeElapsedMonth', renewalPeriod) })}}
          </template>
        </template>
        <template v-else>
          {{ $t('settlements.extendThisPackageBy', { timeTxt: $tc('time.timeElapsedMonth', renewalPeriod) })}}
        </template>
      </f-button>
    </div>
  </div>
</template>
<script>

export default {
  name: 'f-account-package',
  props: {
    isCurrent: {
      defeault: false,
      type: Boolean
    },
    isMinimal: {
      defeault: false,
      type: Boolean
    },
    isPurchaseDisabled: {
      defeault: false,
      type: Boolean
    },
    packageOption: {
      default: () => {},
      type: Object
    },
    renewalPeriod: {
      default: 1,
      type: Number
    },
    showAllCallback: {
      default: null,
      type: Function
    },
    subscribeCallback: {
      default: null,
      type: Function
    }
  },
  computed: {
    currentPackagePriceForPeriod () {
      return this.packageOption.prices.find(item => item.months === this.renewalPeriod);
    },
    classList () {
      let classes = ['package-card'];
      if (this.isCurrent) {
        classes.push('is-highlighted');
      }

      return classes.join(' ');
    }
  },
  data () {
    return {
      packageSettingsOptions: [{
        label: this.$t('ui.comments'),
        value: 'comments'
      }, {
        label: this.$t('ui.messages'),
        value: 'messages'
      }, {
        label: this.$t('client.clients'),
        value: 'customers'
      }, {
        label: this.$t('ui.offers'),
        value: 'inquiries'
      }, {
        label: this.$t('ui.massCommunication'),
        value: 'communications'
      }, {
        label: this.$t('ui.calendar'),
        value: 'calendar'
      }, {
        label: this.$t('articleForm.articles'),
        value: 'articles'
      }, {
        label: this.$t('customer.customerCreditOffers'),
        value: 'credit_offer'
      }]
    }
  }
}
</script>
